import moment from "moment";
/**
 * Flattens day groups into a single array.
 *
 * @param dayGroups
 * @returns Returns only day groups with week number 0.
 */
export const flattenSubscriptionDayGroups = (distributions, startSunday) => {
    const dayGroups = distributions === null || distributions === void 0 ? void 0 : distributions.flatMap((distribution) => {
        var _a;
        if (((_a = distribution.dayGroups) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return (distribution.dayGroups
                // For each day group, override the products property with the distribution's products.
                .map((group) => (Object.assign(Object.assign({}, group), { products: distribution.products }))));
        }
        else {
            // When there are no day groups, return a default day group with the distribution's products.
            return [
                {
                    day: distribution.day,
                    totalCost: distribution.totalCost,
                    discount: 0,
                    discountedCost: 0,
                    priceFloorFee: 0,
                    mealsCost: 0,
                    meals: [],
                    appliedDayBank: undefined,
                    products: distribution.products,
                },
            ];
        }
    }).filter((d) => { var _a; return ((_a = d.day) === null || _a === void 0 ? void 0 : _a.weekNumber) === 0; });
    // Sort the flattened day groups by the day of the week.
    dayGroups === null || dayGroups === void 0 ? void 0 : dayGroups.sort((a, b) => {
        var _a, _b;
        // Get the day of the week number.
        let aNumber = ((_a = a.day) === null || _a === void 0 ? void 0 : _a.dayOfWeek) !== undefined ? moment().day(a.day.dayOfWeek).format("e") : 0;
        let bNumber = ((_b = b.day) === null || _b === void 0 ? void 0 : _b.dayOfWeek) !== undefined ? moment().day(b.day.dayOfWeek).format("e") : 0;
        // If startSunday is false, we need to convert Sunday to 7.
        if (!startSunday && +aNumber === 0)
            aNumber = 7;
        if (!startSunday && +bNumber === 0)
            bNumber = 7;
        return +aNumber - +bNumber;
    });
    return dayGroups;
};
